import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import {
  faBell as farBell,
  faCalendar as farCalendar,
  faCalendarAlt as farCalendarAlt,
  faCalendarPlus as farCalendarPlus,
  faClipboard as farClipboard,
  faClock as farClock,
  faEdit as farEdit,
  faStar as farEmpty,
  faUserCircle as farUserCircle
} from '@fortawesome/free-regular-svg-icons'
import {
  faAnchor, faArrowRight,
  faBars,
  faCaretDown, faCaretRight, faCaretUp, faChartLine,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faDownload,
  faEllipsisH,
  faEraser,
  faExclamationTriangle,
  faEye,
  faEyeSlash, faHome, faLink,
  faLongArrowAltLeft,
  faMapMarkerAlt,
  faPencilAlt,
  faPlus,
  faPlusCircle,
  faStar,
  faTachometerAlt, faThumbtack, faTimes, faTrash,
  faWindowClose,
  faCircleInfo
} from '@fortawesome/free-solid-svg-icons'

@NgModule({
  declarations: [],
  imports     : [
  CommonModule,

  FontAwesomeModule
  ],
  exports: [
  FontAwesomeModule
  ]
  })
export class FontAwesomeVendorModule {
  constructor (private library: FaIconLibrary) {

    [
      faArrowRight,
      faBars,
      faCaretDown,
      faCaretUp,
      faCaretRight,
      faChartLine,
      faCheck,
      faChevronDown,
      faChevronLeft,
      faChevronRight,
      faChevronRight,
      faDownload,
      faEraser,
      faEllipsisH,
      faExclamationTriangle,
      faEye,
      faEyeSlash,
      faLink,
      faLongArrowAltLeft,
      faMapMarkerAlt,
      faPencilAlt,
      faPencilAlt,
      faPlus,
      faPlusCircle,
      faStar,
      faTachometerAlt,
      faTimes,
      faThumbtack,
      faTrash,
      faWindowClose,
      faAnchor,
      faHome,
      farCalendarPlus,
      farEmpty,
      farEdit,
      farUserCircle,
      farBell,
      farClipboard,
      farCalendar,
      farCalendarAlt,
      farClock,
      faCircleInfo
    ].forEach(icon =>
      library.addIcons(icon))
  }
}
